package com.eladfinish.bible.contest.screens.openQuestions

import com.eladfinish.bible.contest.utils.toOtiot

const val NO_TOPICS_ERROR = "אירעה שגיאה - לא נמצאו נושאים, אנא נסו שוב"

const val EMPTY_JSON_ARRAY = "[]"

fun String.getOtiotIfIsNumeric(): String =
    try {
        this.toInt().toOtiot()
    } catch (_: NumberFormatException) {
        this
    }

fun getTranslatedLanguage(languageInHebrew: String): String =
    when (languageInHebrew) {
        "אנגלית" -> "English"
        "ספרדית" -> "Español"
        "צרפתית" -> "Français"
        else -> "עברית"
    }
